import { orderTrackingShipmentSummarySchema } from "@redotech/redo-model/order-tracking/order-tracking-shipment-definition";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const exportOrderTrackingShipments = {
  name: "exportOrderTrackingShipments" as const,
  input: z.object({
    searchString: z.string().optional(),
    filters: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({ shipments: z.array(orderTrackingShipmentSummarySchema) }),
};
